import React, { useState } from 'react';

const parse = (text) => text.split('\n').map((s) => s.trim()).filter(Boolean);

export const KeyFeaturesList = ({ features, tr = (s) => s, testId }) => {
  if (!features || features.length === 0) return null;
  return (
    <ul className="space-y-1.5 mb-4" data-testid={testId}>
      {features.map((f, i) => (
        <li key={i} className="text-sm text-charcoal-600 flex items-start gap-2">
          <span className="text-saffron-500 mt-0.5">✦</span>
          <span>{tr(f)}</span>
        </li>
      ))}
    </ul>
  );
};

export const KeyFeaturesInput = ({ value, onChange, placeholder, testId }) => {
  const [text, setText] = useState((value || []).join('\n'));
  const items = parse(text);
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-charcoal-700">Key Features <span className="text-charcoal-400 font-normal">(press Enter for each new point)</span></label>
      <textarea
        placeholder={placeholder}
        rows={5}
        value={text}
        onChange={(e) => { setText(e.target.value); onChange(parse(e.target.value)); }}
        className="w-full px-4 py-3 rounded-lg border border-charcoal-200 focus:outline-none focus:ring-2 focus:ring-saffron-500"
        data-testid={testId}
      />
      {items.length > 0 && (
        <div className="rounded-lg bg-saffron-50/50 border border-saffron-100 p-3" data-testid={`${testId}-preview`}>
          <p className="text-xs uppercase tracking-wide text-charcoal-500 mb-2">Preview</p>
          <KeyFeaturesList features={items} />
        </div>
      )}
    </div>
  );
};
